module.exports = __webpack_public_path__ + "img/home_pic_3.0_3.945e2313.webp";